import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum DocumentRequestRouteNames {
  DOCUMENT_REQUEST_TABLE = "DOCUMENT_REQUEST_TABLE",
  DOCUMENT_REQUEST_DETAIL = "DOCUMENT_REQUEST_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type DocumentRequestParam = { documentRequestId: string };
type Query = { query?: Record<string, string> };

export class DocumentRequestGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = DocumentRequestGoToHelper.locations;

    return {
      DocumentRequestTable: (partnerId: string) => ({
        text: $t("nav.DOCUMENT_REQUEST_TABLE.title").toString(),
        exact: true,
        to: locations.documentRequestTable({ partnerId })
      }),
      DocumentRequestDetail: (partnerId: string, documentRequestId: string) => ({
        text: $t("nav.DOCUMENT_REQUEST_DETAIL.title").toString(),
        exact: true,
        to: locations.documentRequestDetail({ partnerId, documentRequestId })
      })
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    documentRequestTable: (d: Partner & Query) => ({
      name: DocumentRequestRouteNames.DOCUMENT_REQUEST_TABLE,
      params: { partnerId: d.partnerId },
      query: d.query
    }),
    documentRequestDetail: (d: Partner & DocumentRequestParam & Query) => ({
      name: DocumentRequestRouteNames.DOCUMENT_REQUEST_DETAIL,
      params: { partnerId: d.partnerId, documentRequestId: d.documentRequestId },
      query: d.query
    })
  };

  goToDocumentRequestTable(d: Partner & Tab) {
    return this.go(DocumentRequestGoToHelper.locations.documentRequestTable(d), d.newTab);
  }

  goToDocumentRequestDetail(d: Partner & DocumentRequestParam & Tab) {
    return this.go(DocumentRequestGoToHelper.locations.documentRequestDetail(d), d.newTab);
  }

  setUrl(location: ReturnType<typeof DocumentRequestGoToHelper.locations.documentRequestTable>) {
    return this.router.replace(location).catch(() => undefined);
  }
}
